import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Y si el colegio no me da bolilla?',
    answer: 'Justamente por eso creamos este protocolo. No dependés de que la directora actúe o de que los otros padres se hagan cargo. Le damos las herramientas directamente a tu hijo para que se defienda psicológicamente.'
  }, {
    question: '¿Sirve si mi hijo es muy tímido?',
    answer: "Sí, especialmente para ellos. No le pedimos que sea extrovertido ni que confronte. Le enseñamos a usar su silencio y su postura como un escudo. Es más fácil ser 'aburrido' que ser 'valiente'."
  }, {
    question: '¿Cuánto tarda en hacer efecto?',
    answer: 'Los acosadores buscan una reacción (llanto, enojo, miedo). Cuando aplicás el Escudo de Aburrimiento y le cortás esa recompensa, suelen perder el interés en 24 a 48 horas. Buscan un blanco más fácil.'
  }, {
    question: '¿Es un libro o un curso?',
    answer: 'Es una guía práctica digital (PDF) y audios cortos. Está diseñado para que lo leas en 30 minutos y lo empieces a aplicar esta misma noche. Sin relleno, directo al grano.'
  }];
  return <section className="w-full py-24 px-6 max-w-3xl mx-auto" data-id="element-22">
      <FadeIn data-id="element-23">
        <h2 className="font-playfair text-3xl md:text-4xl text-center text-dark-coffee font-semibold mb-12" data-id="element-24">
          Preguntas Frecuentes
        </h2>
      </FadeIn>

      <div className="space-y-4" data-id="element-25">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <FadeIn key={index} delay={index * 0.1} data-id="element-26">
              <div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-beige border-beige' : 'bg-white border-beige/50 hover:border-beige'}`} data-id="element-27">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-28">
                  <span className="font-playfair text-lg font-semibold text-dark-coffee pr-8" data-id="element-29">
                    {faq.question}
                  </span>
                  <div className={`shrink-0 text-warm-accent transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-30">
                    {isOpen ? <Minus className="w-5 h-5" data-id="element-31" /> : <Plus className="w-5 h-5" data-id="element-32" />}
                  </div>
                </button>

                <AnimatePresence data-id="element-33">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-34">
                      <div className="px-6 pb-5 text-soft-brown leading-relaxed" data-id="element-35">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>;
      })}
      </div>
    </section>;
}